/** ファイル：TOP画面取得 成功. */
export const GET_TOP_SUCCESS = "GET_TOP_SUCCESS";
/** タブを切り替え. */
export const CHANGE_TAB = "CHANGE_TAB";
/** レコメンド取得 成功.*/
export const GET_TOP_RECOMMEND_SUCCESS = "GET_TOP_RECOMMEND_SUCCESS";